import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

/** Kartica „Zamjena" na formi nove narudžbe — vidljiva samo kad narudžba nastaje
 *  iz zahtjeva za povrat. Sam račun živi u `@/lib/exchange-totals`. */
export function ExchangePricingCard({
  shippingCharged,
  onShippingChargedChange,
  priceDifference,
  onPriceDifferenceChange,
  subtotal,
}: {
  shippingCharged: boolean;
  onShippingChargedChange: (value: boolean) => void;
  /** Sirovi unos, da polje može biti prazno dok operater kuca. */
  priceDifference: string;
  onPriceDifferenceChange: (value: string) => void;
  subtotal: number;
}) {
  const parsed = parseFloat(priceDifference || "0");
  const negative = Number.isFinite(parsed) && parsed < 0;
  const aboveSubtotal = Number.isFinite(parsed) && parsed > subtotal;

  return (
    <section className="ring-1 ring-foreground/10">
      <div className="px-3 py-2.5 border-b">
        <span className="text-xs font-medium">Zamjena</span>
      </div>
      <div className="p-3 flex flex-col gap-3">
        <div className="flex items-center justify-between gap-2">
          <Label htmlFor="naplati-dostavu" className="text-xs text-muted-foreground">
            Naplati dostavu
          </Label>
          <Switch
            id="naplati-dostavu"
            checked={shippingCharged}
            onCheckedChange={onShippingChargedChange}
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="text-xs text-muted-foreground">Razlika u cijeni (KM)</Label>
          <Input
            className="h-7 text-xs"
            type="number"
            step="0.01"
            min="0"
            placeholder="0.00"
            value={priceDifference}
            onChange={(e) => onPriceDifferenceChange(e.target.value)}
          />
          {negative && (
            <span className="text-[11px] text-red-400">Razlika ne može biti negativna.</span>
          )}
          {!negative && aboveSubtotal && (
            <span className="text-[11px] text-amber-500">
              Razlika je veća od vrijednosti stavki ({subtotal.toFixed(2)} KM) — provjeri iznos.
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
